/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import Field from 'components/shared/fields/field/field';
import Button from 'components/shared/button/button';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/fields/select/select_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ FIELD : SELECT : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class SelectField extends Component {
	constructor(props) {
		super(props);
		// this.isClicked = false;
		this.state = { isValid: null, currentValue: '', dataSubmitted: false };
	}
	setFieldState = (value, optionId) => this.setState({isValid: this.handleValidation(value) ? true : null,currentValue: value, optionId});
	handleValidation = (value) => value !== '';
	submitData = () => {
		if(this.handleValidation(this.state.currentValue) && !this.state.dataSubmitted) {
            this.setState({dataSubmitted: true });
            this.props.processSubmit({ id: this.state.optionId, text: this.state.currentValue});
        } else {
			this.setState({isValid: this.handleValidation(this.state.currentValue)});
        }
    };
	handleChange = (e) => {
		this.setFieldState(e.target.value, e.target.options[e.target.selectedIndex].getAttribute('optionid'));
		if (e.key === 'Enter') this.submitData();
	};
	handleButtonClick = () => {
		if(!this.state.isClicked) {
			this.submitData()
        }
    };
	render() {
		return (
			<Field hasButton={this.props.hasButton} isValid={this.state.isValid}>
	        	<select id={this.props.id} className={`${sheet.classes.select} select isValid-${this.state.isValid} macos-${this.props.os === 'mac_os'}`} disabled={this.state.dataSubmitted} onKeyUp={this.handleChange} onChange={this.handleChange}>
	        		<option value={``}>Choose below:</option>
	        		{this.props.children}
	        	</select>
	        	{this.props.hasButton ? <Button klass={`button enter${this.state.dataSubmitted ? ' disabled' : ''}`} onClick={this.handleButtonClick}>Enter</Button> : null}
	        </Field>
		);
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default SelectField;
